import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetSpaceTypes, successGetSpaceTypes } from './SpaceTypesSlicer';
import { ISpaceTypesList } from '../../../Pages/SpaceTypes/ISpaceTypes';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  failureAddSpaceTypes,
  successAddSpaceTypes,
} from './AddSpaceTypesSlicer';
import {
  failureUpdateSpaceTypes,
  successUpdateSpaceTypes,
} from './UpdateSpaceTypesSlicer';
import {
  failureDeleteSpaceTypes,
  successDeleteSpaceTypes,
} from './DeleteSpaceTypesSlice';

const SpaceTypesApi = (action: PayloadAction<any>) => {
  return api.get(`/parking-type/${action.payload}`);
};

export function* SpaceTypesCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(SpaceTypesApi, action);
    yield put(successGetSpaceTypes(response.data));
  } catch (error) {
    yield put(failureGetSpaceTypes(error));
  }
}

// add SpaceTypes
const AddSpaceTypesApi = (action: PayloadAction<ISpaceTypesList>) => {
  const data = {
    name: action.payload.name,
    location_id: action.payload.location_id,
    restriction: action?.payload?.restriction?.value,

    restriction_data: action.payload?.restriction_data,
    time_limit: action.payload.time_limit,
    working_hours: action.payload.working_hours,
  };

  return api.post('/parking-type/create', data);
};

export function* AddSpaceTypesCall(action: PayloadAction<ISpaceTypesList>) {
  try {
    const response: AxiosResponse = yield call(AddSpaceTypesApi, action);
    yield put(successAddSpaceTypes(response.data));
  } catch (error) {
    yield put(failureAddSpaceTypes(error));
  }
}

// update SpaceTypes
const UpdateSpaceTypesApi = (action: PayloadAction<ISpaceTypesList>) => {
  // const formData = new FormData();

  // Object.entries(action.payload).forEach(([key, value]) => {
  //   formData.append(key, value);
  // });

  const url = `/parking-type/${action.payload.id}`;
  console.log(action?.payload?.restriction);

  const data = {
    name: action.payload.name,
    location_id: action.payload.location_id,
    restriction: action?.payload?.restriction?.value,

    restriction_data: action.payload?.restriction_data,
    time_limit: action.payload.time_limit,
    working_hours: action.payload.working_hours,
  };

  return api.patch(url, data);
};

export function* UpdateSpaceTypesCall(action: PayloadAction<ISpaceTypesList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSpaceTypesApi, action);
    yield put(successUpdateSpaceTypes(response.data));
  } catch (error) {
    yield put(failureUpdateSpaceTypes(error));
  }
}

// delete SpaceTypes
const DeleteSpaceTypesApi = (action: PayloadAction<number>) => {
  return api.delete(`/parking-type/${action.payload}`);
};
export function* DeleteSpaceTypesCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSpaceTypesApi, action);
    yield put(successDeleteSpaceTypes(response.data));
  } catch (error) {
    yield put(failureDeleteSpaceTypes(error));
  }
}
